import { post, parseData } from '../api/common';
import { responseHandler, returnFullResponseHandler } from '../api/api';
const getAllowances = (options) => {
    return post('/InternalAPI/AllowanceAPI.asmx/GetAllowancesForCurrentCompany', { options })
        .then(parseData)
        .then(responseHandler);
};
const deleteAllowance = (PK) => {
    return post('/InternalAPI/AllowanceAPI.asmx/DeleteAllowance', {
        allowancePK: PK
    })
        .then(parseData)
        .then(responseHandler);
};
const createAllowance = (Allowance) => {
    return post('/InternalAPI/AllowanceAPI.asmx/CreateAllowance', { Allowance })
        .then(parseData)
        .then(returnFullResponseHandler);
};
const updateAllowance = (Allowance) => {
    return post('/InternalAPI/AllowanceAPI.asmx/UpdateAllowance', { Allowance })
        .then(parseData)
        .then(returnFullResponseHandler);
};
export { getAllowances, deleteAllowance, createAllowance, updateAllowance };
